import { Dict } from "@/types/generalTypes";

const defaultOptions = {
  style: "decimal",
  currency: "GBP",
  currencyDisplay: "symbol",
  unitDisplay: "short",
  roundingMode: "halfEven",
  trailingZeroDisplay: "auto",
} as Dict<any>;

export const numberFormatter = (options: Dict<any>, locale = "en-GB") => {
  const formatter = new Intl.NumberFormat(locale, {
    ...defaultOptions,
    ...options,
  });
  const separators = getSeparators(locale);

  const format = (n: number) => {
    let res = formatter.format(n);
    if (options.cUnit) {
      res += " " + options.cUnit;
    }
    return res;
  };

  const parse = (s: string) => {
    s = s.replace(/[^\d.,\-+]/g, "");
    return parseFloat(
      s.replaceAll(separators.group, "").replace(separators.decimal, "."),
    );
  };

  return { format, parse, separators };
};

const getSeparators = (locale: string) => {
  const formatted = new Intl.NumberFormat(locale).format(1234.5);
  return {
    decimal: formatted[5],
    group: formatted[1],
  };
};
